import { apiClient } from '../../api/client';
import { ENDPOINTS } from '../../api/endpoints';

function unwrapApiPayload<T = any>(payload: any): T {
  if (payload && typeof payload === 'object' && 'success' in payload && 'data' in payload) {
    return payload.data ?? payload;
  }
  return payload;
}

export class IdeasService {
  static async list(params?: Record<string, any>): Promise<any[]> {
    const response = await apiClient.get(ENDPOINTS.IDEAS.LIST, { params });
    return unwrapApiPayload(response.data);
  }

  static async getById(id: string | number): Promise<any> {
    const response = await apiClient.get(ENDPOINTS.IDEAS.DETAILS(id));
    return unwrapApiPayload(response.data);
  }

  static async create(data: any): Promise<any> {
    const response = await apiClient.post(ENDPOINTS.IDEAS.CREATE, data);
    return unwrapApiPayload(response.data);
  }

  static async update(id: string | number, data: any): Promise<any> {
    const response = await apiClient.put(ENDPOINTS.IDEAS.UPDATE(id), data);
    return unwrapApiPayload(response.data);
  }

  static async delete(id: string | number): Promise<void> {
    await apiClient.delete(ENDPOINTS.IDEAS.DELETE(id));
  }

  static async addReaction(id: string | number, reaction: string): Promise<any> {
    const response = await apiClient.post(ENDPOINTS.IDEAS.REACTIONS(id), { reaction });
    return unwrapApiPayload(response.data);
  }

  static async getDashboard(id: string | number): Promise<any> {
    const response = await apiClient.get(ENDPOINTS.IDEAS.DASHBOARD(id));
    return unwrapApiPayload(response.data);
  }
}
